import { MaterialLayoutRenderer } from "@jsonforms/material-renderers";
import React from "react";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { rankWith, uiTypeIs } from "@jsonforms/core";

const HorizontalLayoutRenderer = (props) => {
  const { uischema, schema, path, visible, renderers } = props;

  const layoutProps = {
    elements: uischema.elements,
    schema: schema,
    path: path,
    visible: visible,
    uischema: uischema,
    renderers: renderers,
    direction: "row"
  };

  return (
    <MaterialLayoutRenderer {...layoutProps} />
  );
};

export const HorizontalLayoutTester = rankWith(1000, uiTypeIs("HorizontalLayout"));

export default withJsonFormsLayoutProps(HorizontalLayoutRenderer);